module.exports = __webpack_public_path__ + "img/anak-benih-sawit.46d9392c.png";